import React from "react";

const Audio = () => {
	return <div></div>;
};

export default Audio;
